import { ENV } from "../utils";

export class RiskType {
  baseApi = ENV.BASE_API;

  async getRiskTypes(accessToken, active = true) {
    const url = `${this.baseApi}/risk-types?active=${active}`;
    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async createRiskType(accessToken, data) {
    const response = await fetch(`${this.baseApi}/add-risk-type`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async updateRiskType(accessToken, id, data) {
    const response = await fetch(`${this.baseApi}/update-risk-type/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async deleteRiskType(accessToken, id) {
    const response = await fetch(`${this.baseApi}/delete-risk-type/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
